import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { APP_LANGUAGES, DEFAULT_LANGUAGE } from '@app/shared/constants';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { I18nLanguage } from '@shared/language/language.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import LocalStorageService, {
  LocalStorageKey,
} from '@shared/services/local-storage.service';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'math-language-switch',
  imports: [TranslateModule, NzSelectModule, ReactiveFormsModule],
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitchComponent implements OnInit {
  public readonly languages = APP_LANGUAGES;

  private localStorage = inject(LocalStorageService);

  public form = new FormGroup({
    language: new FormControl(''),
  });

  constructor(
    public translateService: TranslateService,
    private destroyRef: DestroyRef,
  ) {
    this.form.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed())
      .subscribe((value) => {
        this.translateService.use(value.language.toLowerCase() as I18nLanguage);
        this.localStorage.setItem(
          LocalStorageKey.UI_LANGUAGE,
          value.language.toLowerCase(),
        );
      });
  }

  ngOnInit(): void {
    this.translateService.onLangChange
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.form.setValue({ language: value.lang.toUpperCase() });
      });
    const currentLanguage = this.localStorage.getItem(
      LocalStorageKey.UI_LANGUAGE,
    );
    this.form.setValue({
      language: currentLanguage?.toUpperCase() || DEFAULT_LANGUAGE,
    });
  }
}
